import CaretDown from '../../assets/inlineSvg/icon-caret-down.svg'
import CaretRight from '../../assets/inlineSvg/icon-caret-right.svg'
import { Button, Select, Toggle, Tooltip, Typography } from '@lightbeamai/design-system'
import './widgetTitle.less'
import classNames from 'classnames'
import React from 'react'

// const WidgetTitleTabs = () => {}
interface DropdownOption {
  key: string
  value: string
  label: string
  onClick?: () => void
}

interface ToggleOption {
  checkedChildren?: React.ReactNode | string
  unCheckedChildren?: React.ReactNode | string
  checked?: boolean
  onClick?: () => void
}
export interface WidgetTitleProps {
  title: string | React.ReactNode | React.ReactElement
  truncateTitle?: boolean
  icon?: React.ReactNode
  subTitle?: string | React.ReactElement
  bordered?: boolean
  tabs?: { key: string; name: React.ReactNode; disabled?: boolean }[]
  activeTab?: string
  action?: React.ReactNode
  onChange?: (tab: string) => void
  dropdowns?: {
    options: DropdownOption[]
    selected: string
    popupClassName?: string
    onChange?: (event: React.SyntheticEvent, data: any) => void
  }[]
  toggle?: ToggleOption
  dropdownTitle?: string
  titleInfo?: React.ReactNode | string
  titleInfoText?: string
  isCollapsible?: boolean
  toggleCollapsed?: () => void
  collapsed?: boolean
}

const WidgetTitle: React.FC<WidgetTitleProps> = (props) => {
  const {
    title,
    truncateTitle = false,
    subTitle,
    bordered,
    activeTab,
    tabs,
    onChange,
    dropdowns = [],
    icon,
    action,
    titleInfo = '',
    titleInfoText = '',
    isCollapsible = false,
    toggleCollapsed,
    collapsed = false,
    toggle
  } = props

  return (
    <div className={classNames('widget-card-title', { 'title-bordered': bordered })}>
      <div className={`widget-title-content ${truncateTitle ? 'truncate' : ''}`}>
        {isCollapsible && (
          <Button className="widget-title-collapse-action" variant="link" onClick={toggleCollapsed}>
            {collapsed ? <CaretRight /> : <CaretDown />}
          </Button>
        )}
        {icon && <div className="widget-title-icon">{icon}</div>}
        <div className={truncateTitle ? 'truncate' : ''} title={title?.toString() || ''}>
          <Typography className={truncateTitle ? 'truncate' : ''} color="primary" variant="h6">
            {title}
          </Typography>
          {subTitle && (
            <Typography color="secondary" variant="baseMinus2">
              {subTitle}
            </Typography>
          )}
        </div>
      </div>

      {tabs && (
        <div className="widget-title-tabs">
          {tabs.map((tab, index) => (
            <button
              key={tab.key + index}
              disabled={tab.disabled}
              className={classNames('tab-item', { 'active-tab': activeTab === tab.key })}
              onClick={() => onChange?.(tab.key)}
            >
              <Typography as={typeof tab.name === 'string' ? 'span' : 'div'}>{tab.name}</Typography>
            </button>
          ))}
        </div>
      )}
      {action && <div className="widget-title-action">{action}</div>}
      {dropdowns.length > 0 && (
        <div className="widget-title-dropdowns">
          {dropdowns.map((dropdown, idx) => {
            return dropdown.options.length && dropdown.onChange ? (
              <Select
                key={idx}
                options={dropdown.options}
                onChange={dropdown.onChange}
                className="widget-title-drop-down-list"
                direction="ltr"
                value={dropdown.selected}
                popupClassName={dropdown.popupClassName}
              />
            ) : null
          })}
        </div>
      )}

      {toggle && (
        <Toggle
          {...(toggle.checkedChildren ? { checkedChildren: toggle.checkedChildren } : {})}
          {...(toggle.unCheckedChildren ? { unCheckedChildren: toggle.unCheckedChildren } : {})}
          {...(typeof toggle.checked === 'boolean' ? { checked: toggle.checked } : {})}
          onClick={toggle.onClick}
          className="widget-title-toggle"
        />
      )}

      {titleInfo && (
        <div className="widget-title-info">
          <Tooltip title={titleInfoText} placement="top" className="widget-title-info-tooltip">
            <Typography color="primary" variant="base" className="truncate widget-title-info-text">
              {titleInfo}
            </Typography>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default WidgetTitle
